import { NavLink, Outlet } from 'react-router-dom';
import { can } from '../lib/roles';
import { useApp } from '../state/AppContext';
import { ProfileNavItem, SidebarBrand, SidebarUser } from './Sidebar';

export function Layout() {
  const { me, users, systems } = useApp();
  const showSystems = can(me.clientRole, 'viewSystems');
  const showAudit = can(me.clientRole, 'viewAudit');
  const showEvents = can(me.clientRole, 'viewEvents');

  return (
    <div className="app">
      <aside className="sidebar">
        <SidebarBrand />
        <nav className="sidebar-nav">
          <NavLink
            to="/users"
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="5" r="2.6" stroke="currentColor" strokeWidth="1.4" />
              <path
                d="M2.8 13.2c.8-2.2 2.8-3.4 5.2-3.4s4.4 1.2 5.2 3.4"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
              />
            </svg>
            <span className="nav-label">Users</span>
            <span className="nav-count">{users.length}</span>
          </NavLink>
          {showSystems && (
            <NavLink
              to="/systems"
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="2" y="2" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.4" />
                <rect x="9" y="2" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.4" />
                <rect x="2" y="9" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.4" />
                <rect x="9" y="9" width="5" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.4" />
              </svg>
              <span className="nav-label">Systems</span>
              <span className="nav-count">{systems.length}</span>
            </NavLink>
          )}
          {showAudit && (
            <NavLink
              to="/audit"
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" />
                <path
                  d="M8 4.8V8l2.2 1.6"
                  stroke="currentColor"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                />
              </svg>
              <span className="nav-label">Audit log</span>
            </NavLink>
          )}
          {showEvents && (
            <NavLink
              to="/events"
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M1.8 8.4h3l1.6-4.2 2.2 8 1.5-3.8h3.1"
                  stroke="currentColor"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="nav-label">Keycloak events</span>
            </NavLink>
          )}
          <ProfileNavItem />
        </nav>
        <SidebarUser />
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
